import { BoldIcon, ChevronDownIcon } from 'lucide-react'

import { Button } from '@/components/new/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger,
} from '@/components/new/ui/dropdown-menu'

import { RichTextEditorActionDefinition, RichTextEditorActionId } from './editor/actions'

type RichTextEditorInlineFormattingMenuProps = {
    actions: RichTextEditorActionDefinition[]
    compact: boolean
    disabled?: boolean
    hasTextSelection: boolean
    label: string
    onRunAction: (actionId: RichTextEditorActionId) => void
}

export const RichTextEditorInlineFormattingMenu = ({
    actions,
    compact,
    disabled,
    hasTextSelection,
    label,
    onRunAction,
}: RichTextEditorInlineFormattingMenuProps) => {
    if (actions.length === 0) {
        return null
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    type="button"
                    variant="ghost"
                    size={compact ? 'icon-xs' : 'sm'}
                    disabled={disabled}
                    aria-label={label}
                    className={compact ? undefined : 'px-2'}
                >
                    <BoldIcon />
                    {!compact && <ChevronDownIcon data-icon="inline-end" className="text-muted-foreground size-3.5" />}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" side="bottom" sideOffset={6}>
                <DropdownMenuGroup>
                    <DropdownMenuLabel>{label}</DropdownMenuLabel>
                    {actions.map((action) => {
                        const Icon = action.icon

                        return (
                            <DropdownMenuItem
                                key={action.id}
                                disabled={disabled || !hasTextSelection}
                                onClick={() => onRunAction(action.id)}
                            >
                                <Icon />
                                {action.label}
                            </DropdownMenuItem>
                        )
                    })}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
